export * from './duplicate-course-dialog.component';
export * from './duplicate-course-dialog.module';
